module.exports = __webpack_public_path__ + "images/fa-career-track-4.jpg";